// extracted by mini-css-extract-plugin
export default {"mobile":"style_mobile__BsxIj","text":"style_text__HK8nv"};